import { genReplaceEmpty } from '../../../utils/helper'
import { TipoArticuloInputProps } from '../interfaces'

export const tipoArticuloActualizarComposeService = (
  input: TipoArticuloInputProps,
): TipoArticuloInputProps => {
  return {
    codigo: genReplaceEmpty(input.codigo, ''),
    descripcion: genReplaceEmpty(input.descripcion, ''),
    grupoUnidadMedida: input.grupoUnidadMedida,
    notas: genReplaceEmpty(input.notas, []).map((item: string) => ({
      key: item,
      value: item,
    })),
  }
}
